import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./GapFinancingSection.css";
import loanApplicationUtility from "../../../utilities/LoanApplicationUtility";
import { LoanType } from "shared/Enums";

interface DealerPurchaseSectionProps {
  loanDetails: LoanApplication
}

export default class GapFinancingSection extends React.Component<DealerPurchaseSectionProps> {
  render() {
    return (
      <>
        {this.props.loanDetails.loanType === LoanType.GapFinancing && this.props.loanDetails.loanGapFinancing !== undefined &&
          (<>
            <div>
              <h3>Wildfire Gap Financing Details</h3>
              <Table bordered striped={false} size="sm">
                <tbody>
                  <>
                    <tr>
                      <td width="250px" className="app-info"><strong>Government Agency</strong></td>
                      <td className="app-info">{this.props.loanDetails.loanGapFinancing.governmentAgency}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Average Reimbursement Request</strong></td>
                      <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanGapFinancing.averageReimbursementAmount)}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Average Reimbursement Length</strong></td>
                      <td className="app-info">{`${this.props.loanDetails.loanGapFinancing.averageReimbursementLength} month(s)`}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Total Assets</strong></td>
                      <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanGapFinancing.totalAssets)}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Total Liabilities</strong></td>
                      <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanGapFinancing.totalLiabilities)}</td>
                    </tr>
                  </>
                </tbody>
              </Table>
            </div>
          </>)
        }
      </>
    );
  }
}